/**
 * UnionsRealTimeChat API v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { MessageViewEmodjiDto } from './messageViewEmodjiDto';


export interface ChatEventReactionsChangedContentDto { 
    /**
     * id сообщения
     */
    messageId: string;
    /**
     * id чата, в котором событие
     */
    chatId: string;
    /**
     * Список с реакциями в виде эмодзи
     */
    emodjies: Array<MessageViewEmodjiDto>;
}

